import { all, call, put, takeLatest, delay } from "redux-saga/effects";
import {
  fetchUserProfileData,
  saveUserProfileData,
  saveUserProfileSettingData,
  apiDeleteUserProfile,
  apiAuthenticateUser,
  apiSaveUserAccessRequest,
  updateUserProfileData,
} from "./api";
import {
  actionFetchUserProfileDataSuccess,
  actionSaveUserProfileDataSuccess,
  actionFetchUserProfileData,
  actionFetchUserIdProfileDataSuccess,
  actionSaveUnRegisterUserDataSuccess,
  actionFetchUserIdSettingProfileDataSuccess,
  actionUpdateUserSettingSuccess,
  actionFetchAuthenticationSuccess,
} from "./actions";
import { ActionTypes } from "./constants";
import {
  setLoaderVisibility,
  openToaster,
  closeToaster,
} from "../../actions/common";
import {
  API_ERROR_MESSAGE,
  DATA_SAVE_SUCCESS,
  DATA_UPDATE_SUCCESS,
} from "../../constants/error";
import { CommonConstant } from "src/constants/data";
import { getLocalDateFromMoment } from "src/utils";
import { USERS_PATH } from "src/constants/api";
import { history } from "../../store/config";

function* watchGetUserProfileData() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_USER_FETCH_DATA,
    getUserProfileData
  );
}

function* getUserProfileData(action: any): any {
  try {
    yield put(setLoaderVisibility(true));
    const response = yield call(fetchUserProfileData, action.payload.lookUp);
    const responseData = response.data;
    if (responseData && responseData.length) {
      responseData.data.map(
        (up: any) => (up.createdOn = getLocalDateFromMoment(up.createdOn))
      );
    }
    yield put(actionFetchUserProfileDataSuccess(responseData.data));
    yield put(setLoaderVisibility(false));
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster(API_ERROR_MESSAGE, false));
    ////console.log(err);
  }
}

function* watchGetUserIdProfileData() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_USER_ID_FETCH_DATA,
    getUserIdProfileData
  );
}

function* getUserIdProfileData(action: any): any {
  try {
    yield put(setLoaderVisibility(true));
    const response = yield call(fetchUserProfileData, action.payload.lookUp);
    const responseData = response.data;
    yield put(actionFetchUserIdProfileDataSuccess(responseData));
    yield put(setLoaderVisibility(false));
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster(API_ERROR_MESSAGE, false));
    //console.log(err);
  }
}

function* watchSaveUserProfileData() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_SAVE_USER_DATA,
    saveUSerProfileData
  );
}

function* saveUSerProfileData(action: any): any {  
  try {
    yield put(setLoaderVisibility(true));
    let response: any;
    if (action.payload.userProfileData.id) {
      response = yield call(
        updateUserProfileData,
        action.payload.userProfileData
      );
    } else {
      response = yield call(
        saveUserProfileData,
        action.payload.userProfileData
      );
    }

    const responseData = response.data;

    if (responseData.success) {
      yield put(setLoaderVisibility(true));
      if (
        action.payload.userProfileData.id !== undefined &&
        action.payload.userProfileData.id !== ""
      ) {
        yield put(openToaster(DATA_UPDATE_SUCCESS, true));
      } else {
        yield put(openToaster(DATA_SAVE_SUCCESS, true));
      }

      if (
        action.payload.userProfileData.id &&
        action.payload.userProfileData.id ===
        action.payload.userProfileData.loggedInUserId
      ) {
        window.location.reload();
      }
      yield put(actionFetchUserProfileData("-1"));
      history.push("/");
      history.push(USERS_PATH);
    } else {
      yield put(openToaster(responseData.message, false));
    }

    yield put(setLoaderVisibility(false));
    yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
    yield put(closeToaster());
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster("Error while saving data", false));
    //console.log(err);
  }
}

function* watchSaveUnRegisterUserData() {
  yield takeLatest(
    ActionTypes.UNREGISTER_USER_SAVE_DATA,
    saveUnRegisterUSerData
  );
}

function* saveUnRegisterUSerData(action: any): any {
  try {
    yield put(setLoaderVisibility(true));
    const response = yield call(
      saveUserProfileData,
      action.payload.userProfileData
    );
    const responseData = response.data;
    yield put(actionSaveUnRegisterUserDataSuccess(responseData));

    if (responseData !== undefined && responseData !== "") {
      yield put(openToaster(responseData, true));
    } else {
      yield put(openToaster("User registration sent", true));
    }

    yield put(setLoaderVisibility(false));
    yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
    yield put(closeToaster());
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster(API_ERROR_MESSAGE, false));
    //console.log(err);
  }
}

function* watchGetUserIdProfileSettingData() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_SETTING_USER_ID_DATA,
    getUserIdProfileSettingData
  );
}

function* getUserIdProfileSettingData(action: any): any {
  try {
    const response = yield call(fetchUserProfileData, action.payload.lookUp);
    const responseData = response.data;

    yield put(actionFetchUserIdSettingProfileDataSuccess(responseData));
  } catch (err) {
    yield put(openToaster(API_ERROR_MESSAGE, false));
    //console.log(err);
  }
}

function* watchUpdateUserSetting() {
  yield takeLatest(ActionTypes.USER_PROFILE_UPDATE_SETTING, updateUserSetting);
}

function* updateUserSetting(action: any): any {
  try {
    const response = yield call(
      saveUserProfileSettingData,
      action.payload.userSetting
    );
    const responseData = response.data;
    yield put(actionUpdateUserSettingSuccess(responseData));
  } catch (err) {
    yield put(openToaster(API_ERROR_MESSAGE, false));
    //console.log(err);
  }
}

function* watchDeleteUserProfile() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_DELETE_USER_PROFILE,
    deleteUserProfile
  );
}

function* deleteUserProfile(action: any): any {
  try {
    yield put(setLoaderVisibility(true));
    const response = yield call(apiDeleteUserProfile, action.payload.data);
    yield put(setLoaderVisibility(false));
    if (response.data.success) {
      yield put(actionFetchUserProfileData("-1"));
      yield put(openToaster(response.data.message, true));
      yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
      yield put(closeToaster());
    } else {
      yield put(openToaster(response.data.message, false));
      yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
      yield put(closeToaster());
    }
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster(API_ERROR_MESSAGE, false));
  }
}

function* watchAuthenticateUser() {
  yield takeLatest(
    ActionTypes.FETCH_IS_AUTHETICATED,
    fnAuthenticateUser
  );
}

function* fnAuthenticateUser(action: any): any {
  try {
    const response = yield call(apiAuthenticateUser);
    if (response.status === 200) {
      yield put(actionFetchAuthenticationSuccess(response.data));
    }
  } catch (err) {
    //console.log(err);
  }
}

function* watchSaveUserAccessRequest() {
  yield takeLatest(
    ActionTypes.USER_PROFILE_SAVE_USER_ACCESS_REQUEST_DATA,
    fnSaveUserAccessRequest
  );
}

function* fnSaveUserAccessRequest(action: any): any {
  try {
    yield put(setLoaderVisibility(true));
    const response = yield call(apiSaveUserAccessRequest, action.payload.data);
    if (response.data.success) {
      yield put(openToaster("Request sent successfully", true));
     
      yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
      
      yield put({
        type: ActionTypes.USER_PROFILE_ACCESS_REQUEST_SENT_SUCCESS,
        payload: true,
      });     
    }
    else {
      yield put(openToaster(response.data.message, false));
    }

    yield put(setLoaderVisibility(false));
    yield delay(CommonConstant.SHOW_TOSTER_TIME_INTERVEL);
    yield put(closeToaster());
  } catch (err) {
    yield put(setLoaderVisibility(false));
    yield put(openToaster(API_ERROR_MESSAGE, false));
  }
}


export default function* userProfileSaga() {
  yield all([
    watchGetUserProfileData(),
    watchSaveUserProfileData(),
    watchGetUserIdProfileData(),
    watchSaveUnRegisterUserData(),
    watchGetUserIdProfileSettingData(),
    watchUpdateUserSetting(),
    watchDeleteUserProfile(),
    watchAuthenticateUser(),
    watchSaveUserAccessRequest(),
  ]);
}
